/* src/app/shared/components/copy-content/copy-content.component.scss */
.material-symbols-outlined:hover {
  color: var(--primary-500);
}
.material-symbols-outlined {
  font-size: 0.9rem;
  cursor: pointer;
}
/*# sourceMappingURL=copy-content.component.css.map */
